import React from "react";

const InsightsResearchIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_804_26018)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93298 3.80817C10.3761 3.80817 11.5459 2.63836 11.5459 1.19531H13.039C13.0391 2.63836 14.2089 3.80817 15.6519 3.80817L15.652 5.30127C14.2089 5.30127 13.039 6.47112 13.039 7.91419L12.2925 7.91426H11.5459C11.5459 6.4712 10.3761 5.30127 8.93298 5.30127V3.80817ZM13.7592 9.18175C13.7767 9.37907 13.7856 9.57877 13.7856 9.78064C13.7856 13.4914 10.7774 16.4996 7.06661 16.4996C3.35583 16.4996 0.347656 13.4914 0.347656 9.78064C0.347656 6.06987 3.35583 3.06169 7.06661 3.06169C7.26847 3.06169 7.46818 3.07059 7.66549 3.08802C7.51894 3.55077 7.43988 4.04354 7.43988 4.55479V4.56792C7.31663 4.55921 7.1921 4.55479 7.06661 4.55479C4.18045 4.55479 1.84076 6.89448 1.84076 9.78064C1.84076 12.6668 4.18045 15.0065 7.06661 15.0065C9.95277 15.0065 12.2925 12.6668 12.2925 9.78064C12.2925 9.65514 12.2881 9.53062 12.2793 9.40736H12.2925C12.8037 9.40736 13.2965 9.3283 13.7592 9.18175ZM7.06661 7.91426C7.2781 7.91426 7.45541 7.84274 7.59852 7.69963C7.74164 7.55652 7.81316 7.37923 7.81316 7.16771C7.81316 6.95619 7.74164 6.77889 7.59852 6.6358C7.45541 6.4927 7.2781 6.42116 7.06661 6.42116C6.85511 6.42116 6.6778 6.4927 6.53469 6.6358C6.39158 6.77889 6.32006 6.95619 6.32006 7.16771C6.32006 7.37923 6.39158 7.55652 6.53469 7.69963C6.6778 7.84274 6.85511 7.91426 7.06661 7.91426ZM6.32006 9.40736V13.1401H7.81316V9.40736H6.32006Z"
          fill="#B1B1B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_804_26018">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InsightsResearchIcon;
